import { ChangeEvent, useState } from "react";
import { ReactComponent as Plus } from 'assets/common/filePlus.svg'
import { toast } from "react-toastify";

interface DragDropProps {
    onChangeFileMulti: (files: File[] | null) => void;
    description?: string;
    disabled?: boolean
    id?: string
}

const DragFileMulti = ({
    onChangeFileMulti,
    description = "파일 첨부",
    disabled = false,
    id
}: DragDropProps) => {

    // 사용자가 파일을 드래드 중임을 상태로 관리 UI 변경을 위해 사용
    const [dragOver, setDragOver] = useState<boolean>(false);
    const MEGABYTES = 15;
    const MAX_FILE_SIZE = MEGABYTES * 1024 * 1024;

    // 드래그 중인 요소가 목표 지점 진입할때
    const handleDragEnter = (e: React.DragEvent<HTMLLabelElement>) => {
        if (disabled) return
        e.preventDefault();
        e.stopPropagation();
        setDragOver(true);
    };

    // 드래그 중인 요소가 목표 지점을 벗어날때
    const handleDragLeave = (e: React.DragEvent<HTMLLabelElement>) => {
        if (disabled) return
        e.preventDefault();
        e.stopPropagation();
        setDragOver(false);
    };

    // 드래그 중인 요소가 목표 지점에 위치할때
    const handleDragOver = (e: React.DragEvent<HTMLLabelElement>) => {
        if (disabled) return
        e.preventDefault();
        e.stopPropagation();
    };

    // 드래그 중인 요소가 목표 지점에서 드롭될때
    const handleDrop = (e: React.DragEvent<HTMLLabelElement>) => {
        if (disabled) return
        e.preventDefault();
        e.stopPropagation();
        setDragOver(false);

        // 드래그되는 데이터 정보와 메서드를 제공하는 dataTransfer 객체 사용
        if (e.dataTransfer) {
            const filesArray = Array.from(e.dataTransfer.files);
            // PDF가 아니거나 사이즈 초과된 파일이 있는 경우 에러 메시지 표시
            const validFiles = filesArray.filter((file) => {
                if (!file.type.includes('pdf')) {
                    toast.error(`"${file.name}"은 PDF 파일이 아닙니다.`);
                    return false;
                }

                if (file.size > MAX_FILE_SIZE) {
                    toast.error(`"${file.name}"은 ${MEGABYTES}MB 이하만 업로드 가능합니다.`);
                    return false;
                }

                return true;
            });

            // 유효한 파일이 있을 경우에만 콜백 호출
            if (validFiles.length > 0) {
                onChangeFileMulti(validFiles);
            }
        }
    };

    // Drag & Drop이 아닌 클릭 이벤트로 업로드되는 기능도 추가
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) {
            return;
        }
        if (e.target.files.length > 0) {
            const filesArray = Array.from(e.target.files)
            onChangeFileMulti(filesArray)
        }

        // input 요소의 값 초기화
        e.target.value = "";
    };

    return (
        <div className="mb-1 w-full">
            <label
                className={`flex flex-col items-center justify-center border-2 border-dashed gap-3 h-35 rounded cursor-pointer
                    bg-[#F8F8FA] text-xs
                    ${dragOver
                        ? "border-primary text-primary"
                        : "border-[#9D9EB7] text-[#A8A9BF]"
                    }`}
                htmlFor={id ? id : "fileUpload"}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
            >
                <Plus />
                <p className="text-center" dangerouslySetInnerHTML={{ __html: description }}></p>
            </label>

            <input
                id={id ? id : "fileUpload"}
                type="file"
                disabled={disabled}
                className="hidden"
                onChange={handleChange}
                accept=".pdf"
                multiple
            ></input>
        </div>
    );
};


export default DragFileMulti;